import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { resolveApiPath } from '@codametrix/client-api';
import { authenticationContext } from '@codametrix/ui-common';

const authLink = setContext((_, { headers }) => {
  const token = authenticationContext.getToken();
  const authorization = token
    ? token.startsWith('Bearer')
      ? token
      : `Bearer ${token}`
    : '';
  return {
    headers: {
      ...headers,
      authorization,
    },
  };
});

let _client: ApolloClient<any> | null = null;

export const getQAApolloClient = (): ApolloClient<any> => {
  if (!_client) {
    const httpLink = createHttpLink({
      uri: resolveApiPath('/api/service-desk/bff'),
    });
    _client = new ApolloClient({
      link: authLink.concat(httpLink),
      cache: new InMemoryCache({
        typePolicies: {
          ManagerHomeGrader: { keyFields: false },
        },
      }),
    });
  }
  return _client;
};
